import {
  Action,
  NgxsOnInit,
  Selector,
  State,
  StateContext,
  Store,
} from '@ngxs/store';
import {
  LoadBrainImages, LoadBrainImagesSuccess, SetColor,
} from './print-card.actions';
import {HttpClient} from '@angular/common/http';
import {BackendError} from '../../../messages/messages.actions';
import { Injectable } from '@angular/core';
import {BrainImage, PrintCardStateModel} from './print-card.models';

@State<PrintCardStateModel>({
  name: 'print_card',
  defaults: {
    colorDict: {},
    color: 'green'
  },
})

@Injectable()
export class PrintCardState {
  constructor(
    private store: Store,
    private http: HttpClient,
  ) {}

  @Selector()
  static imageUrl(state: PrintCardStateModel) {
    const color = state.color;
    const colorDict = state.colorDict;
    if (color) {
      if (colorDict[color]) {
        const img = colorDict[color];
        return `/api/research/scan/brain-image/${img.id}`;
      } else {
        return `/assets/images/3d-print/${color}.webp`
      }
    } else {
      return `/assets/images/3d-print/green.webp`
    }

  }

  @Action(LoadBrainImages)
  loadBrainImages({dispatch}: StateContext<PrintCardStateModel>) {
    this.http.get<BrainImage[]>('/api/research/scan/brain-images').subscribe(
      images => dispatch(new LoadBrainImagesSuccess(images)),
      err => dispatch(new BackendError(err)),
    );
  }

  @Action(LoadBrainImagesSuccess)
  loadBrainImagesSuccess({patchState}: StateContext<PrintCardStateModel>, {brainImages}: LoadBrainImagesSuccess) {
    const colorDict = {};
    for (const image of brainImages) {
      colorDict[image.color] = image;
    }

    patchState({colorDict});
  }

  @Action(SetColor)
  setColor({patchState}: StateContext<PrintCardStateModel>, {color}: SetColor) {
    patchState({color});
  }

}
